import React, { Suspense } from "react";
import { LoadingSpinner } from "src/components/ui/loading-spinner";

const AwsIntegrationsDialog = React.lazy(() => import("./AwsIntegrationsDialog"));

interface AwsIntegrationsDialogLazyProps {
  isOpen: boolean;
  onClose: () => void;
  onRefetch?: () => void;
  brandTheme?: string | null;
}

export default function AwsIntegrationsDialogLazy(props: AwsIntegrationsDialogLazyProps) {
  return (
    <Suspense fallback={<div className="flex justify-center p-4"><LoadingSpinner /></div>}>
      <AwsIntegrationsDialog {...props} />
    </Suspense>
  );
}
